import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Drawer, List, ListItem, ListItemText, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png'

const navLinks = [
  { label: 'Home', link: '/' },
  { label: 'Articles', link: '/articles?status=1' },
  { label: 'Editorial Board', link: '/editorial-board?status=1' },
  { label: 'Peer Reviewers', link: '/peer-reviewers?status=1' },
  { label: 'Logout', link: '/auth' },
];

function AdminNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavClick = (link, label) => {
    if (label === 'Logout') {
      localStorage.removeItem('admin');
    }
    navigate(link);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: '#1a1a1a' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          {/* Logo */}
          <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img src={logo} alt="Logo" style={{ height: 40, marginRight: 10 }} />
            <Typography
              variant="h6"
              sx={{ textDecoration: 'none', color: '#fff' }}
            >
              Admin Panel
            </Typography>
          </Box>

          {/* Desktop Nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            {navLinks.map((item) => (
              <Button
                key={item.label}
                color="inherit"
                sx={{ textTransform: 'none' }}
                onClick={() => handleNavClick(item.link, item.label)}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Mobile Icon */}
          <IconButton color="inherit" edge="end" onClick={toggleMobileDrawer} sx={{ display: { md: 'none' } }}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="top" open={mobileOpen} onClose={toggleMobileDrawer}>
        <Box sx={{ p: 2, backgroundColor: '#1a1a1a', color: '#fff', height: '100vh' }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton onClick={toggleMobileDrawer} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {navLinks.map((item) => (
              <ListItem
                button
                key={item.label}
                onClick={() => {
                  toggleMobileDrawer();
                  handleNavClick(item.link, item.label);
                }}
              >
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default AdminNavbar;
